<template>
  <modal name="onesync" height="auto" width="390px" :scrollable="true" :shiftY="0.2">
    <div class="close">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="$modal.hide('onesync')"  alt="">
    </div>
    <div class="modal-form">
      <div class="progress-bar-container" v-if="upload">
        <vue-ellipse-progress
                :progress="bar.progress"
                color="#2CB181"
                :size="140"
                :thickness="5"
                :empty-thickness="3"
                :legend-value="bar.processed"
                font-color="#2CB181"
                empty-color="#c0e8d9"
        >
          <span slot="legend-value"> / {{bar.all_count}}</span>
          <span slot="legend-caption">{{done}}</span>

        </vue-ellipse-progress>
      </div>
      <h4 class="title">Введите ссылку на xml</h4>
      <div class="input-block">
        <input
            type="text"
            autocomplete="off"
            v-model="url"
            name="url"
            data-vv-validate-on="blur"
            data-vv-as="Адрес сервера 1С"
            v-validate="'required|url'"
        >
        <span class="text-danger text-sm">{{ errors.first('url') }}</span>
      </div>
      <div class="btn">
        <button @click="save()" :disabled="disabled">Сохранить</button>
      </div>
    </div>
  </modal>
</template>

<script>

export default {
  name: "one-c-sync-modal",
  data: ()=> ({
    url: '',
    local_url: '',
    bar: {
      page: 0,
      progress: 0,
      processed: 0,
      all_count: 0,
      id: ''
    },
    disabled: false,
    upload: false,
    done: ''
  }),
  methods: {
    open(){
      this.$modal.show('onesync');
    },
    clear(){
      this.url = ''
    },
    sync() {
      this.upload = true;
      this.disabled = true;
      this.$http.post( '/parse-products',{
        token: localStorage.getItem('token'),
        url: this.url,
        local_url: this.local_url,
        page: this.bar.page,
        id: this.bar.id
      }).then(({data}) => {
        if (data.data.page) {
          this.bar = data.data;
          this.local_url = data.data.local_url;
          this.sync();
        }

        if (data.data.success == 1) {
          this.done = 'Загрузка завершена';
          this.bar.progress = 100;
          this.bar.processed = this.bar.all_count;
          this.local_url = '';
        }
      }).catch(function(){
        this.$toast.error('Ошибка!');
      })
    },
    save(){
      this.$validator.validateAll()
          .then(success => {
            if(success){
              this.sync();
              /*this.$emit('save', this.url);
              this.$modal.hide('onesync');
              this.clear();*/
            }
          })
    }
  }
}
</script>

<style scoped lang="scss">

.progress-bar-container {
  width: 140px;
  margin: 0px auto;
}

.btn{
  width: 100%;
  padding: 0;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  padding: 30px;
}
.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
input{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
</style>